import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { fetchGuides, setActiveGuide } from '../Guides/actions'
import { createEvent } from '../UserEvents/actions'
import { SingleGuide } from '../../components'
import { selectCurrentPhone, selectPreSaleFlag } from '../App/selectors'
import { selectContactOptions } from '../ContactUsModal/selectors'
import {
  selectGuides,
  selectActiveGuide,
  selectGuidesFetching
} from '../Guides/selectors'
import { DeviceNotLoadedHOC } from '../../hocs'
import { browserHistory } from 'react-router'

// Reducer, saga of this container lives in '../Guides/reducer.js'
const SingleGuideContainer = ({
  params,
  guides,
  currentPhone,
  isFetching,
  preSaleFlag,
  query,
  createUserEvent,
  contactOptions,
  router
}) => {
  const [activeGuideId, setActiveGuideId] = useState()
  const [guideIdOrSlug, setGuideIdOrSlug] = useState()

  useEffect(() => {
    setGuideIdOrSlug(params.id)
  }, [params.id])

  useEffect(() => {
    if (!guideIdOrSlug || !guides.length) {
      return
    }
    const guideBySlug = guides.find(guide => guide.slug === guideIdOrSlug)
    if (guideBySlug) {
      setActiveGuideId(guideBySlug.val)
      return
    }

    const guideById = guides.find(
      guide => parseInt(guide.val, 10) === parseInt(guideIdOrSlug, 10)
    )
    if (guideById) {
      router.replace({
        pathname: `/guides/${guideById.slug}`,
        query
      })
      return
    }
    /** Otherwise, route to Guides index */
    router.push({
      pathname: `/guides`,
      query
    })
  }, [guideIdOrSlug, guides.length])

  if (params.id && !activeGuideId) {
    return null
  }

  const activeGuide = guides.find(
    guide => parseInt(guide.val, 10) === parseInt(activeGuideId, 10)
  )

  return (
    <SingleGuide
      relatedType="related"
      currentPhone={currentPhone}
      activeGuide={activeGuide}
      isFetching={isFetching}
      preSaleFlag={preSaleFlag}
      query={query}
      router={router}
      createUserEvent={createUserEvent}
      hideContactButton={
        contactOptions.length > 0 && contactOptions[0].link_location === 'hide'
      }
    />
  )
}

const mapStateToProps = state => ({
  currentPhone: selectCurrentPhone(state),
  preSaleFlag: selectPreSaleFlag(state),
  guides: selectGuides(state),
  activeGuide: selectActiveGuide(state),
  isFetching: selectGuidesFetching(state),
  query: state.routing.locationBeforeTransitions.query,
  contactOptions: selectContactOptions(state)
})

const mapDispatchToProps = dispatch => ({
  fetchGuides: currentPhoneId => dispatch(fetchGuides.request(currentPhoneId)),
  setActiveGuide: activeGuide => dispatch(setActiveGuide(activeGuide)),
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceNotLoadedHOC(SingleGuideContainer))



// WEBPACK FOOTER //
// ./src/containers/SingleGuide/SingleGuide.js